import React from 'react';
import { SiInstagram, SiTiktok, SiFacebook } from 'react-icons/si';
import Gallery from '../components/Gallery/Gallery';
import EventsCarousel from '../components/Events/EventsCarousel';
import AnnouncementBar from '../components/Announcement/AnnouncementBar';
import './HomePage.css';

const HomePage = () => {
  const bannerUrl = process.env.PUBLIC_URL + '/media/Banner.jpg';

  return (
    <div className="homepage">
      {/* Navigation */}
      <nav className="navbar">
        <div className="container">
          <a href="#home" className="logo" aria-label="Royal China Home">
            <img src="/media/Logo.png" alt="Royal China Logo" className="logo-image" />
          </a>
          <div className="nav-links">
              <a className="social-icon instagram" href="https://www.instagram.com/royalchinaaberdeen/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <SiInstagram className="social-svg" />
              </a>
              <a className="social-icon tiktok" href="https://www.tiktok.com/@royalchina_aberdeen?_r=1&_d=secCgYIASAHKAESPgo89OyvAMYHJCpbE%2BUzTinc5k4Sn2xRHDdQEiNaDyej4iGkuWF%2B3GRfYMIv9aNfsUuZleJiUghhNfDY3u1IGgA%3D&_svg=2&checksum=3a05e574fce44ac10af78d249ffb405bc7278c0319bb0462b303eee851c2c663&item_author_type=1&sec_uid=MS4wLjABAAAAA3bPKg0CNS4N6g_p9pclOawP8Ilxhxt9plLKhmq_XRr0IqVK879A2PQQzZfGRYpG&sec_user_id=MS4wLjABAAAAA3bPKg0CNS4N6g_p9pclOawP8Ilxhxt9plLKhmq_XRr0IqVK879A2PQQzZfGRYpG&share_app_id=1233&share_author_id=7468361060282827798&share_link_id=462B5FDB-3897-456A-BACE-A38C85BE10EE&share_region=GB&share_scene=1&sharer_language=en&social_share_type=4&source=h5_m&timestamp=1765659617&tt_from=copy&u_code=eii5h59mmj7fab&ug_btm=b8727%2Cb0&user_id=7468361060282827798&utm_campaign=client_share&utm_medium=ios&utm_source=copy" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                <SiTiktok className="social-svg" />
              </a>
              <a className="social-icon facebook" href="https://www.facebook.com/p/Royal-China-Restaurant-61578051323704/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <SiFacebook className="social-svg" />
              </a>
            <a href="/admin/login" className="admin-link">Log In</a>
          </div>
        </div>
      </nav>

      {/* Announcement bar — hidden automatically when inactive or empty */}
      <AnnouncementBar />

      {/* Hero Section */}
      <section
        id="home"
        className="hero"
        style={{
          // Use a lighter translucent black so the banner image remains visible
          backgroundImage: `linear-gradient(rgba(0,0,0,0.25), rgba(0,0,0,0.25)), url('${bannerUrl}')`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-content">
          <h1>Royal China - Peterculter</h1>
          <p className="hero-subtitle">Experience Authentic Northern and Southern Chinese Cuisine</p>
          <p className="hero-description">
            Indulge in the rich flavors and traditions of Chinese culinary techniques. 
            From simple Hong Kong homecooking style of sweet and sour chicken to aromatic duck, 
            every dish is crafted with passion and authenticity.
            <br />For explorers of taste, we additionally specialise in Thai and Korean flavours.
          </p>
          <div className="hero-cta">
            <a
              className="btn btn-primary btn-large takeaway-btn menu-btn"
              href="#menu"
              aria-label="View Our Menu"
            >
              View Our Menu
            </a>
            <a
              className="btn btn-primary btn-large takeaway-btn"
              href="https://www.royalchinaaberdeen.co.uk/online-ordering"
              target="_blank"
              rel="noopener noreferrer"
            >
              Order Takeaway
            </a>
          </div>
          <hr className="hero-divider" />
          <p className="address-line">
            Royal China Restaurant, 309 N Deeside Rd, Peterculter, Aberdeen AB14 0UL
          </p>
          <a
            className="btn btn-secondary btn-large directions-btn"
            href="https://www.google.com/maps/dir//309+N+Deeside+Rd,+Peterculter,+Aberdeen+AB14+0UL/@56.4697185,-2.988106,14z/data=!4m8!4m7!1m0!1m5!1m1!1s0x4884176ec7729efd:0xbae435005dd9accc!2m2!1d-2.2707376!2d57.0961357?authuser=1&entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get Directions
          </a>
        </div>
      </section>

      {/* Events Carousel — hidden automatically when there are no active events */}
      <EventsCarousel />

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <h2>Our Story</h2>
          <div className="about-content">
            <div className="about-text">
              <p>
                Royal China, nestled in the heart of Peterculter, a beloved Chinese-Cantonese style eatery.  
                Our chefs originate from China with over 20 years experience throughout China, London and Edinburgh. 
                We boast a fresh culinary vision, led by a team of talented chefs who bring a wealth of authentic flavors to the table. 
              </p>
              <p>
                The restaurant offers traditional yet innovative cuisine and promise our customers fresh and delicious Chinese dishes.  
                Additionally, we offer Thai and Korean cuisines cooked in traditional techniques, to give you more variety and choice.   
                We strive to deliver an unforgettable dining experience with a the combination of good food and a relaxing restaurant setting.
                This reflects the essence of Chinese culture: Good food, happiness and health in harmony.
              </p>
            </div>
            <div className="about-features">
              <div className="feature">
                <h3>🍜 Authentic Recipes</h3>
                <p>We use traditional ingredients to reflect the cultural heritage of southern and northern cuisine.</p>
              </div>
              <div className="feature">
                <h3>🌟 Fresh Ingredients</h3>
                <p>Locally sourced and imported premium ingredients</p>
              </div>
              <div className="feature">
                <h3>👨‍🍳 Expert Chefs</h3>
                <p>Trained in the finest culinary traditions of China</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="gallery">
        <div className="container">
          <h2>Gallery</h2>
          <p className="section-subtitle">A visual journey through our culinary delights</p>
          {(
            () => {
              const media = [
                { type: 'video', src: '/media/Wok 1.mp4', alt: 'Wok cooking 1' },
                { type: 'image', src: '/media/Restaurant 1.jpg', alt: 'Restaurant interior 1' },
                { type: 'video', src: '/media/Food Rotating.mov', alt: 'Rotating food display' },
                { type: 'video', src: '/media/Bao Bun.mov', alt: 'Bao bun preparation' },
                { type: 'image', src: '/media/Restaurant 2.jpg', alt: 'Restaurant interior 2' },
                { type: 'image', src: '/media/Restaurant 3.JPG', alt: 'Restaurant interior 3' },
                { type: 'image', src: '/media/Restaurant 4.jpg', alt: 'Restaurant interior 4' },
                { type: 'video', src: '/media/Set Meal.mp4', alt: 'Set meal plating' },
                { type: 'image', src: '/media/Noodles.jpg', alt: 'Noodles' }
              ];
              return <Gallery items={media} />;
            }
          )()}
        </div>
      </section>

      {/* Menu Section */}
      <section id="menu" className="menu">
        <div className="container">
          <h2>Menu</h2>
          <p className="section-subtitle">View our full menu</p>
          <div className="menu-container">
            <object
              data="/media/Royal_China_Menu.pdf"
              type="application/pdf"
              className="menu-pdf"
              aria-label="Restaurant Menu PDF"
            >
              <p>
                Your browser does not support embedded PDFs. 
                <a href="/media/Royal_China_Menu.pdf" target="_blank" rel="noopener noreferrer">Open the menu in a new tab</a>.
              </p>
            </object>
          </div>
        </div>
      </section>

           {/* Meal Deals Section */}
      <section id="meal-deals" className="meal-deals">
        <div className="container">
          <h2>Meal Deals</h2>
          <p className="section-subtitle">Check out our special meal deals</p>
          <div className="meal-deals-container">
            <img 
              src="/media/Meal deal lunch.jpeg" 
              alt="Meal Deal Lunch" 
              className="meal-deal-image"
            />
            <img 
              src="/media/Meal deal thurs sun mon.jpeg" 
              alt="Meal Deal Thursday Sunday Monday" 
              className="meal-deal-image"
            />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Royal China</h3>
              <p>Bringing authentic Chinese cuisine to your table</p>
            </div>
            <div className="footer-section">
              <h3>Contact</h3>
              <p>Phone: 01224 732333</p>
              <p>Email: royalchinaadn@gmail.com</p>
              <p>Website: www.royalchinarestaurant.co.uk</p>
              <p>Address: 309 N Deeside Rd, Peterculter, Aberdeen AB14 0UL</p>
            </div>
            <div className="footer-section">
              <h3>Hours</h3>
              <p>Mon-Fri: 12:00pm-02:30pm / 4:30pm-10pm</p>
              <p>Sat-Sun: 12:00pm-10:00pm</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 Royal China Restaurant. All rights reserved.</p>
            <p>Website by Stewart Scrimgeour</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
